/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import SectionTitle from '@components/Headings/SectionTitle';
import SimpleFaq from '@landing_pages/GoY/SimpleFaq';
import MidContainer from '@Layout/MidContainer';

/* Services */

/**
 *
 * @param {Object} param0
 * @returns
 */
const ImportantInformation = ({ section }) => {
  return (
    <MidContainer w={'768'}>
      <Box
        textAlign="center"
        width="100%"
        mt={{ base: '60px', md: '40px' }}
        mb="80px"
        p="0 20px"
      >
        <SectionTitle titleObj={section?.sectionContent[0]} />
        <SimpleFaq faqSection={section?.sectionContent[1]} />
      </Box>
    </MidContainer>
  );
};

export default ImportantInformation;
